import React from 'react';
import { useTranslation } from 'react-i18next';

const ChangeRole =({ memberId, username, newRole, prevRole }) => {
    const { t } = useTranslation();
    const text = prevRole === 'agent' ? 
        t('changeRoleFromAgent') : 
        t('changeRole', {username, prevRole, newRole});

    return (
        <div className={`changeRole`}>
            <div className={`text`}>{text}</div>
        </div>
    );
};

export default ChangeRole;
